/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupRecordingResponseExistingRecordingDupIsrcsInner
 */
export interface LookupRecordingResponseExistingRecordingDupIsrcsInner {
    /**
     * Recording ID the ISRC is being reassigned from
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecordingDupIsrcsInner
     */
    dupRecordingId: string;
    /**
     * OpenSearch document ID of the source recording
     * @type {string}
     * @memberof LookupRecordingResponseExistingRecordingDupIsrcsInner
     */
    dupDocumentId: string;
    /**
     * ISRCs (all in `recording.isrcs`) being reassigned from this recording
     * @type {Array<string>}
     * @memberof LookupRecordingResponseExistingRecordingDupIsrcsInner
     */
    isrcs: Array<string>;
}

/**
 * Check if a given object implements the LookupRecordingResponseExistingRecordingDupIsrcsInner interface.
 */
export function instanceOfLookupRecordingResponseExistingRecordingDupIsrcsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;
    isInstance = isInstance && "isrcs" in value;

    return isInstance;
}

export function LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSON(json: any): LookupRecordingResponseExistingRecordingDupIsrcsInner {
    return LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSONTyped(json, false);
}

export function LookupRecordingResponseExistingRecordingDupIsrcsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponseExistingRecordingDupIsrcsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dupRecordingId': json['dup_recording_id'],
        'dupDocumentId': json['dup_document_id'],
        'isrcs': json['isrcs'],
    };
}

export function LookupRecordingResponseExistingRecordingDupIsrcsInnerToJSON(value?: LookupRecordingResponseExistingRecordingDupIsrcsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dup_recording_id': value.dupRecordingId,
        'dup_document_id': value.dupDocumentId,
        'isrcs': value.isrcs,
    };
}

